// styles
import {
  StyledMessageBubble,
  StyledMessageRow
} from './ChatMessageBubble.styles';

// types
import type { ChatMessageBubbleProps } from './ChatMessageBubble.types';

const ChatMessageBubble = ({ role, text }: ChatMessageBubbleProps) => {
  'use memo';

  const isUser = role === 'user';

  return (
    <StyledMessageRow isUser={isUser}>
      <StyledMessageBubble isUser={isUser} variant="body2">
        {text}
      </StyledMessageBubble>
    </StyledMessageRow>
  );
};

export default ChatMessageBubble;
